import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Images } from 'lucide-react';

const INVOICE_STYLE = {
  paid: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  sent: 'bg-sky-500/15 text-sky-300 border-sky-500/30',
  draft: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
};
const money = (c) => `$${((c || 0) / 100).toFixed(2)}`;

export const OrderBillingBadges = ({ info }) => {
  if (!info) return null;
  const inv = info.invoice;
  return (
    <>
      {info.photo_count > 0 && (
        <span className="inline-flex items-center gap-1 text-xs text-[#E8E4DE]/60" data-testid="client-order-gallery">
          <Images className="h-3.5 w-3.5" />{info.photo_count} photos
        </span>
      )}
      <Badge variant="outline" className={inv ? INVOICE_STYLE[inv.status] : 'border-white/10 text-[#E8E4DE]/40'} data-testid="client-order-invoice">
        {inv ? `${inv.invoice_number} · ${inv.status} · ${money(inv.status === 'paid' ? (inv.amount_paid_cents ?? inv.total_cents) : inv.total_cents)}` : 'No invoice'}
      </Badge>
    </>
  );
};

export const BillingSummary = ({ billing }) => {
  const invoices = Object.values(billing).map((b) => b.invoice).filter(Boolean);
  if (!invoices.length) return null;
  const paid = invoices.filter((i) => i.status === 'paid').reduce((s, i) => s + (i.amount_paid_cents ?? i.total_cents ?? 0), 0);
  const due = invoices.filter((i) => i.status === 'sent').reduce((s, i) => s + (i.total_cents || 0), 0);
  const drafts = invoices.filter((i) => i.status === 'draft').length;
  return (
    <div className="grid grid-cols-3 gap-2 mb-4" data-testid="client-billing-summary">
      {[['Paid', money(paid), 'text-emerald-300'], ['Awaiting payment', money(due), 'text-sky-300'], ['Draft invoices', drafts, 'text-amber-300']].map(([label, value, cls]) => (
        <div key={label} className="rounded-lg bg-[#050816]/40 p-3">
          <p className="text-[11px] uppercase tracking-wider text-[#E8E4DE]/50">{label}</p>
          <p className={`text-lg ${cls}`}>{value}</p>
        </div>
      ))}
    </div>
  );
};
